"use client"

import { useState } from "react"
import type { Notification, NotificationNotifiableDocusignEnvelope } from "@/schema"

import { downloadDocusignEnvelope } from "@/hooks/api/households/docusign-envelopes/api"
import { useApiContext } from "@/hooks/api/use-api-context"
import { GenericDialog } from "@/components/dialogs"

interface SignedDocumentDialogProps {
  open: boolean
  setOpen: (open: boolean) => void
  notification: Notification | null
}

export function SignedDocumentDialog({ open, setOpen, notification }: SignedDocumentDialogProps) {
  const getContext = useApiContext()
  const [downloading, setDownloading] = useState(false)

  if (!notification) return null

  const envelope = notification.notifiable as NotificationNotifiableDocusignEnvelope

  const handleDownload = async () => {
    setDownloading(true)
    const context = await getContext()
    const { url } = await downloadDocusignEnvelope(context, envelope.household_id!, String(envelope.id!))
    window.open(url, "_blank", "noopener,noreferrer")
    setDownloading(false)
    setOpen(false)
  }

  return (
    <GenericDialog
      open={open}
      onOpenChange={setOpen}
      dismiss="explicit"
      title={notification.message}
      description={
        envelope.envelope_status === "completed"
          ? "The signed document is ready for download."
          : `Envelope status: ${envelope.envelope_status}`
      }
      action={
        envelope.has_signed_document && envelope.household_id
          ? { label: "Download", onClick: handleDownload, pending: downloading }
          : undefined
      }
    />
  )
}
